/* jshint esversion: 6, -W097 */
/* globals require */
(function (angular) {
    'use strict';
    var app = angular.module('enervee');

    /*
     Creates checkout buy button directive
     <checkout-buy-button></checkout-buy-button>
     */

    app.directive('checkoutBuyButton', [function () {
        return {
            restrict: 'E',
            replace: true,
            scope: {
                productDetailData: '=',
                checkoutInfo: '='
            },
            controller: [
                '$log',
                '$scope',
                '$filter',
                'CartAnalyticsService',
                'EnerveeCheckoutService',
                'UtilService',
                function (
                    $log,
                    $scope,
                    $filter,
                    CartAnalyticsService,
                    EnerveeCheckoutService,
                    UtilService
                ) {
                    $scope.utilityTitle = UtilService.getSiteSetting('title');
                    $scope.cmsContext = {
                        utilityTitle: $scope.utilityTitle,
                        price: $scope.checkoutInfo.price - $scope.checkoutInfo.total_additional_discounts
                    };
                    $scope.rebateAmount = false;

                    if ($scope.productDetailData.rebates) {
                        $scope.productDetailData.rebates.forEach(rebate => {
                            if (rebate.amount && rebate.highestInType === true) {
                                $scope.rebateAmount = true;
                                $scope.cmsContext.price -= rebate.amount;
                            }
                        })
                    }

                    $scope.cmsContext.price = '<span>' + $filter('toCurrency')($scope.cmsContext.price);

                    $scope.addProductToCart = function () {
                        var id = $scope.productDetailData.id;
                        EnerveeCheckoutService.addProductToCart(id, 1).then(function success() {
                            CartAnalyticsService.reportEvent('Cart Engaged', {
                                location: 'sidebar',
                                type_of_change: 'Add Product',
                            }, $scope.productDetailData);
                        }, function error(error) {
                            $log.warn('Enervee Checkout Error: ' + error);
                        });
                    };
                }
            ],

            template: require('@app/shared/integrations/enerveeCheckout/buyButton/checkoutBuyButtonView.html')
        };
    }]);

})(angular);
